import { Outlet } from 'react-router-dom';
import SentryTestButton from './SentryTestButton';
import PWAInstallGuide from './PWAInstallGuide';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { shouldShowInstallGuide, dismissInstallGuide } from '../utils/pwaUtils';

const AppWrapper = () => {
	const { user, settings } = useSelector((state) => state.header);
	const [showInstallGuide, setShowInstallGuide] = useState(false);

	useEffect(() => {
		// Check if we should show the PWA install guide
		if (shouldShowInstallGuide()) {
			const timer = setTimeout(() => {
				setShowInstallGuide(true);
			}, 3000);
			return () => clearTimeout(timer);
		}
	}, []);

	const handleCloseInstallGuide = () => {
		setShowInstallGuide(false);
		dismissInstallGuide();
	};

	return (
		<>
			<Outlet />
			{user?.id && (
				<PWAInstallGuide
					isVisible={showInstallGuide}
					onClose={handleCloseInstallGuide}
					orgName={settings?.organization?.name}
					orgLogo={settings?.companyLogo}
				/>
			)}
			<SentryTestButton />
		</>
	);
};

export default AppWrapper;
